import { moduleApiGraph } from '@t/module-api-graph';
export default async function getAdGroupId(thirdPartyLabel: string): Promise<string> {
    const group = await moduleApiGraph.Client.api("/groups/?$filter=displayName+eq+'" + thirdPartyLabel + "'").get();
    if (group && group.value && group.value.length > 0) {
        return group.value[0].id;
    }
    return '';
}
